import ChannelSearch from '@/docs-partials/api/endpoints/channel-search.mdx';
import * as React from 'react';
export default {
  ChannelSearch,
  React
};